<template>
  <div class="welcome">
    <div class="box">
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welcome',
  data() {
    return {
      imgList: [],
      input: ''
    }
  },
  mounted() {
    const urlParams = this.getUrlParam(window.location.href)
    let url = ''
    // 开发模式
    if (process.env.NODE_ENV === 'development') {
      url = encodeURIComponent(
        'http://17l.link/?id=' +
          urlParams.id +
          '&targetName=' +
          urlParams.targetName +
          '&wechatLogin=' +
          urlParams.wechatLogin +
          '&redirect=' +
          urlParams.redirect +
          '&a=1111'
      )
    } else {
      // 线上模式
      url = encodeURIComponent(
        'http://17l.link/dist/?id=' +
          urlParams.id +
          '&targetName=' +
          urlParams.targetName +
          '&wechatLogin=' +
          urlParams.wechatLogin +
          '&redirect=' +
          urlParams.redirect +
          '&a=1111'
      )
    }
    console.log(url)
    console.log(urlParams)
    if (window.location.href.indexOf('redirect') >= 0) {
      // 有此参数，说明网页授权获取了code
      this.$common.session.set('code', urlParams.code) // 微信code
      this.$common.session.set('targetName', urlParams.targetName) // 需要跳转的页面
      this.$common.session.set('id', urlParams.id) // 公司id
      this.$router.push({
        name: 'Blank',
        params: {
          id: urlParams.id,
          targetName: urlParams.targetName,
          code: urlParams.code
        }
      })
    } else if (urlParams.wechatLogin) {
      // 是否微信登录
      this.$common.storage.set('cid', urlParams.id)
      window.location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx66b5ace206eaded0&redirect_uri=' +
        url +
        '&response_type=code&scope=snsapi_userinfo&state=1111#wechat_redirect'
    } else if (urlParams.targetName) {
      this.$router.push({
        name: urlParams.targetName
      })
    } else {
      this.$router.push('/login')
    }
  },
  methods: {
    // 解析页面URL
    getUrlParam(url) {
      var paramStr = url.substring(url.indexOf('?') + 1, url.length).split('&')
      var j
      var paramObj = {}
      for (var i = 0; (j = paramStr[i]); i++) {
        console.log(i)
        paramObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length)
      }
      var returnValue = paramObj
      if (typeof returnValue === 'undefined') {
        return ''
      } else {
        return returnValue
      }
    }
  },
  destroyed() {}
}
</script>

<style lang="less" scoped>
.welcome {
  .box {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 10vw;
    }
  }
}
</style>
